import Search from "../components/Search";
import Stack from "../components/Utils/Stack.styled";
import { motion, AnimatePresence } from "framer-motion";
import { Outlet, useLocation } from "react-router-dom";
import NavBar from "../components/Nav";
import useNavigateParams from "../helper/navigateHelper";
import { useState, useEffect } from "react";
import usePlayListStore from "../stores/playlistStore";
import { fetchPlaylistDetails } from "../helper/useApiHelper";
import ErrorMessage from "../components/ErrorMessage";
import CONSTANT from "../constants/constant";
import { useErrorState } from "../contexts/errorContext";
import { useStatus } from "../contexts/statusContext";

const MainScreen = () => {
  const { setIsError } = useErrorState();
  const { statusKey, setStatusKey } = useStatus();
  const navigate = useNavigateParams();
  const param = useLocation();
  const [showMainSearch, setShowingMainSearch] = useState(true);
  const allPlaylistsId = usePlayListStore((state) => state.allPlaylistsId);
  const getCurrentPlaylist = usePlayListStore(
    (state) => state.getCurrentPlaylist
  );

  // Update status toast
  useEffect(() => {
    let interval;
    if (statusKey) {
      interval = setInterval(() => setStatusKey(null), 4000);
    }
    return () => {
      clearInterval(interval);
    };
  }, [statusKey, setStatusKey]);

  for (const [key, playlistId] of allPlaylistsId.entries()) {
    const { data, error } = fetchPlaylistDetails(playlistId);
    if (data && data.data) {
      getCurrentPlaylist(data.data, key);
    }
    if (error) {
      setIsError(true);
      return (
        <ErrorMessage
          title={CONSTANT.ERROR.TITLE}
          message={CONSTANT.ERROR.NOT_FOUND_MESSAGE}
        />
      );
    }
  }

  const getCurrentSearchKey = (key) => {
    setShowingMainSearch(false);
    navigate("/results", { q: key });
  };

  const renderMainSearch = () => {
    return (
      <Stack
        as={motion.div}
        key="mainSearch"
        initial={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{
          duration: 1,
        }}
        direction="column"
        style={{
          minHeight: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Search
          as={motion.div}
          layoutId="search"
          onSearch={getCurrentSearchKey}
          showLogo
        />
      </Stack>
    );
  };

  const getStatus = (val) => {
    if (val) {
      setShowingMainSearch(false);
    }
  };

  return (
    <AnimatePresence>
      <NavBar key="nav" hideSearch={showMainSearch} onClick={getStatus} />
      {showMainSearch || param.pathname === "/" ? renderMainSearch() : ""}
      <Outlet />
    </AnimatePresence>
  );
};

export default MainScreen;
